import React, { useState } from 'react'
import { Modal, Row, Col, FormControl, FormLabel } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'
import * as ajax from '../Utilities/ajax'
import { BiPlusMedical } from "react-icons/bi";
import { AiOutlineDelete } from "react-icons/ai";
import { IconButton, Tooltip } from '@material-ui/core'
import { Alert } from '@material-ui/lab';

export default function SectionOrTag(props) {

  const [option, setOption] = useState([])
  const [newValue, setNewValue] = useState(undefined)
  const [loading, setLoading] = useState(false)
  const [loadingA, setLoadingA] = useState(false)
  
  React.useEffect(() => {
    setOption(props.open.val)
  }, [props.open.val])

  const handleTags = (label) => {
    let newOptions = []
    newOptions = option.filter(v => v.label !== label)
    setOption(newOptions)
  }

  const handleLoading = async () => {
    const ticket = newData()
    setLoadingA(true)
    await ticket
    setLoadingA(false)
  }

  const newData = () => {
    let _newValue = {
      label: newValue,
      value: newValue,
      id: undefined 
    }
    option.push(_newValue)
    const options = option
    setOption(options)
  }

  const handleForm = (event) => {
    setNewValue(event.target.value)
  }
  const handleConfirm = async () => {
    setLoading(true)
    let options = option
    await ajax.post(`/video/handleCompany`, options).then(res => res.data).catch(err => console.log(err))
    setLoading(false)
    props.callback(props.open.page, props.open.value)
  }

  return (
    <Modal show={props.open.show} >
      <Modal.Header>
        <Modal.Title>{ "Edit Company" }</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{maxHeight: "500px", overflowY: "auto"}}>
          {!loadingA ? (option || []).map((v, i) => (
            <Row key={i} style={{ marginTop: '6px', marginRight: "10px" }}>
            <Col xs={10} >
              <Alert variant="outlined" severity="success" color="info">
                {v.value}
              </Alert>
            </Col>
            <Col xs={2}>
              <Tooltip title={"Delete Company"} aria-label="delete">
                <IconButton aria-label="delete" onClick={() => handleTags(v.label)}>
                  <AiOutlineDelete style={{color: "red"}} />
                </IconButton>
              </Tooltip>
            </Col>
          </Row>
          )): " "}
        </div>
        <Row style={{marginRight: "10px"}}>
          <Col xs={4} sm={3}><FormLabel className="labelTextSection" style={{width:100}}>{"New Company"}</FormLabel></Col>
          <Col xs={6} sm={7} style={{ marginTop: '6px' }} >
            <FormControl type="text" name="new" placeholder="Company" onChange={handleForm} />
          </Col>
          <Col xs={2} sm={2} style={{display: "flex", alignItems: "center", justifyContent: "center", padding: 0}} >
            <Tooltip title="Edit Tag" aria-label="add">
              <IconButton aria-label="delete" onClick={handleLoading}>
                <BiPlusMedical style={{ marginTop: "3px" ,fontSize: "24px", cursor: "pointer" }}  />
              </IconButton>
            </Tooltip>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle="primary"
          loading={loading}
          onClick={handleConfirm}
        >
          {loading ? 'Please wait' : 'Save'}
        </Button>
        <Button bsStyle="default" onClick={() => props.callback(props.open.page, props.open.value)}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}
